import React from 'react';
import { Row, Col } from 'react-bootstrap';
import map from 'lodash.map';
import { format } from 'date-fns';
import Bet from './Bet';

function Bets(props) {
    let { betslip, closeModal } = props;

    let drawBets = map(betslip.bets, (bet) => {
        return <Bet bet={bet} bettype_id={betslip.bettype_id} key={bet.id} />;
    });

    let betType = betslip.bettype_id === 1 ? 'Single' : 'Combination';

    return (
        <div className="fs-13">
            <Row className="mx-auto px-2 fs-13">
                <Col xs={12} md={12} className="pr-2 pt-2 text-right">
                    <i className="material-icons" onClick={closeModal}>
                        close
                    </i>
                </Col>
            </Row>

            <Row className="mx-auto text-gray px-2 fs-13">
                <Col xs={3} md={3} className="pt-0 px-2 pb-2">
                    <time>{format(betslip.created_at, 'kk:mm')}</time>
                </Col>
                <Col xs={3} md={3} className="pt-0 px-2 pb-2">
                    <time>{format(betslip.created_at, 'dd/MM/yy')}</time>
                </Col>
                <Col xs={6} md={6} className="pt-0 px-2 pb-2 text-right">
                    Type: {betType}
                </Col>
            </Row>

            <div className="cashout-divider"></div>

            {drawBets}

            <Row className="mx-auto text-gray px-2 pt-2 fs-13">
                <Col className="pt-0 px-2 pb-2 text-right"> {parseFloat(betslip.odds).toFixed(2)}</Col>
            </Row>

            <Row className="mx-auto text-gray px-2 fs-13">
                <Col className="pt-0 px-2 pb-2 text-right">Total stake: {parseFloat(betslip.stake).toFixed(2)}</Col>
            </Row>

            <Row className="mx-auto text-gray px-2 fs-13">
                <Col className="pt-0 px-2 pb-2 text-right">Total win: {parseFloat(betslip.win).toFixed(2)}</Col>
            </Row>

            <div className="mb-2"></div>
        </div>
    );
}

export default Bets;
